module.exports = __webpack_public_path__ + "img/ring_g_0_0_null@2x.5f396c7c.png";